export default {
	field: 'provider.name',
	name: 'Manufacturer',
	width: '200px',
}
